<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>
    <div
      v-if="isLoading === true"
      class="text-center mb-2"
    >
      <b-spinner
        variant="primary"
        label="Text Centered"
      />
    </div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-between">
      <label
        class="mr-1 h4"
        style="color:black"
      >Nombre de bons de livraison : {{ orders.length }}</label>

      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Recherche de bon de livraison</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Rechercher par numéro BL, client, téléphone..."
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <b-form-group>
          <b-button
            v-if="user.role ==='supplier'"
            :to="{ name: 'order-add' }"
            variant="gradient-primary"
            class="ml-1 d-inline-block"
          >
            <feather-icon icon="PlusIcon" />
            <span class="ml-1">Ajouter un bon de livraison</span>
          </b-button>
        </b-form-group>
        <b-form-group>
          <b-button
            variant="gradient-primary"
            class="ml-1 d-inline-block"
            :class="{ 'disabled-cursor': selectedOrders.selectedRows.length ===0 }"
            :disabled="selectedOrders.selectedRows.length ===0"
            @click="printAll"
          >
            <feather-icon icon="PrinterIcon" />
            <span class="ml-1">Impression groupée</span>
          </b-button>
        </b-form-group>
      </div>
    </div>

    <!-- Modern empty state UI for no data found (matching pickups/Index.vue) -->
    <div
      v-if="orders.length === 0 && !isLoading"
      class="empty-state"
    >
      <div class="empty-icon">
        <feather-icon
          icon="FileTextIcon"
          size="80"
        />
      </div>
      <div class="empty-title">
        Aucun bon de livraison trouvé
      </div>
      <div class="empty-description">
        <span v-if="user.role === 'supplier'">
          Vous n'avez pas encore créé de bons de livraison.<br>
          Cliquez sur le bouton ci-dessous pour en ajouter un nouveau.
        </span>
        <span v-else>
          Aucun bon de livraison n'est disponible pour le moment.
        </span>
      </div>
      <div v-if="user.role === 'supplier'">
        <b-button
          :to="{ name: 'order-add' }"
          variant="gradient-primary"
          class="empty-action mt-2"
        >
          <feather-icon icon="PlusIcon" />
          <span class="ml-1">Créer un bon de livraison</span>
        </b-button>
      </div>
    </div>
    <vue-good-table
      v-else
      ref="my-table"
      :columns="columns"
      :rows="orders"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'bons sélectionnés',
        clearSelectionText: 'Tout désélectionner',
        disableSelectInfo: false, // enable the select info panel to show selection count
      }"
      @on-selected-rows-change="selectionChanged"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <div
          v-if="props.column.field === 'id'"
          class="text-nowrap"
        >
          <qrcode-vue
            style="display:inline"
            :value="props.row.id.toString()"
            :size="size"
            level="H"
          />

        </div>
        <span v-if="props.column.field === 'status'">
          <div v-if="props.row.status === 0">
            <b-badge
              class="badge-glow bg-warning bg-lighten-1"
              pill
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span> en attente</span>
            </b-badge>
          </div>
        </span>
        <span v-if="props.column.field === 'status'">
          <div v-if="props.row.status === 1">
            <b-badge
              class="badge-glow bg-warning bg-darken-2"
              pill
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span> en pickup </span>
            </b-badge>
          </div>
        </span>
        <span v-if="props.column.field === 'status'">
          <div v-if="props.row.status === 15">
            <b-badge
              class="badge-glow bg-info"
              pill
            >
              <feather-icon
                icon="ClockIcon"
                class="mr-25"
              />
              <span> en attente de collecte </span>
            </b-badge>
          </div>
        </span>
        <!-- Column: Common -->

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Affichage 1 à</span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="(value) => props.perPageChanged({ currentPerPage: value })"
            />
            <span class="text-nowrap">de {{ props.total }} résultats trouvés</span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import axios from 'axios'
import QrcodeVue from 'qrcode.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import storeAuth from '@/store/store'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BBadge,
    QrcodeVue,
  },
  data() {
    return {
      size: 80,
      pageLength: 3,
      dir: false,
      columns: [], // Initialize as empty array
      user: {}, // Initialize as empty object
      orders: [], // Initialize as empty array
      searchTerm: '',
      isLoading: false,
      selectedOrders: {
        selectedRows: [],
      },
    }
  },
  created() {
    this.user = storeAuth.state.user
    this.columns = this.getColumns() // Set columns after user is available
    this.getOrders()
  },
  methods: {
    printAll() {
      const selected = this.$refs['my-table'].selectedRows
      if (selected.length === 0) {
        this.showToast('danger', 'top-center', 'vous devez sélectionner au minimum un colis')
      } else {
        const orderIds = selected.map(x => x.id).join(',')
        this.$router.push({ name: 'print-all', params: { orderIds } })
      }
    },
    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)
      const h = date.slice(11, 19)
      return `${year}-${month.padStart(2, '0')}-${day1.padStart(
        2,
        '0',
      )} | ${h}`
    },
    async getOrders() {
      try {
        this.isLoading = true
        const { data } = await axios.get('/api/orders/get-delivery-notes/')
        // Data is now already formatted by the backend serializer
        this.orders = data
        this.isLoading = false
      } catch (error) {
        setTimeout(() => {
          this.showToast('danger', 'top-center', error.toString())
        }, 1000)
      }
    },
    selectionChanged(selectedRows) {
      this.selectedOrders = selectedRows
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
    getColumns() {
      const baseColumns = [
        {
          label: 'N° BL',
          field: 'id',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher N° BL',
          },
        },
        {
          label: 'Destinataire',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher destinataire',
          },
        },
      ]

      // Conditionally add supplier column (only for non-supplier users)
      if (this.user.role !== 'supplier') {
        baseColumns.push({
          label: 'Expéditeur',
          field: 'supplier',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher expéditeur',
          },
        })
      }

      // Add remaining columns
      const remainingColumns = [
        {
          label: 'Gouvernorat',
          field: 'governorate',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher gouvernorat',
          },
        },
        {
          label: 'Délégation',
          field: 'delegation',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher délégation',
          },
        },
        {
          label: 'Téléphone',
          field: 'phone1',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher téléphone',
          },
        },
        {
          label: 'Statut',
          field: 'status',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher statut',
          },
        },
        {
          label: 'Montant TTC',
          field: 'price_ttc',
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher montant TTC',
          },
        },
        {
          label: 'Date de création',
          field: 'created_at',
          formatFn: this.formatFn,
          filterOptions: {
            enabled: true,
            placeholder: 'Chercher date de création',
          },
        },
      ]

      return [...baseColumns, ...remainingColumns]
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

// Modern empty state UI (copied from pickups/Index.vue)
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 2rem;
  background: rgba(232, 0, 0, 0.1);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E80000;
}
.empty-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
}
.empty-description {
  color: #6b7280;
  margin-bottom: 2rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  font-size: 1.1rem;
  line-height: 1.6;
}
.empty-action {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #E80000 0%, #c70000 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  box-shadow: 0 4px 12px rgba(232, 0, 0, 0.3);
}
.empty-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(232, 0, 0, 0.4);
  color: white;
  text-decoration: none;
}
</style>
